import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const AIGenFill = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="AIGenFill" {...props}>
    <path d="M18.8974 12.8572C19.7935 13.0788 19.7935 14.3526 18.8974 14.5742C15.0741 15.5198 12.0888 18.505 11.1433 22.3284C10.9217 23.2245 9.64788 23.2245 9.42628 22.3284C8.48072 18.505 5.49548 15.5198 1.67211 14.5742C0.776046 14.3526 0.776046 13.0788 1.67211 12.8572C5.49548 11.9117 8.48073 8.92644 9.42628 5.10307C9.64788 4.20701 10.9217 4.20701 11.1433 5.10307C12.0888 8.92644 15.0741 11.9117 18.8974 12.8572Z" fill="#000" /><path d="M22.6759 5.09447C23.1079 5.18991 23.1079 5.80577 22.6759 5.90122C20.7923 6.31741 19.3212 7.78855 18.905 9.6722C18.8095 10.1042 18.1937 10.1042 18.0982 9.6722C17.682 7.78855 16.2109 6.3174 14.3272 5.90122C13.8953 5.80577 13.8953 5.18991 14.3272 5.09447C16.2109 4.67828 17.682 3.20714 18.0982 1.32349C18.1937 0.89152 18.8095 0.891519 18.905 1.32349C19.3212 3.20714 20.7923 4.67828 22.6759 5.09447Z" fill="#000" />
  </StyledIcon>
));

AIGenFill.displayName = 'AIGenFill';

export { AIGenFill };
